// extracted by mini-css-extract-plugin
export default {"ghost":"cYHrklo106gL3To7D0Qg"};